import React, { useState } from 'react';

import Section from '/react4xp/components/Section';
import Button from '/react4xp/components/Button';

import { Loading } from '/react4xp/components/Svg/Ux/Ux';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(advancedFormat)

interface Props {
   heading: string
   info?: {
      email: {
         label: string
         value: string
      }
      file: {
         label: string
         value: string
      }
      date: {
         label: string
         value: string
      }
      isApproved: boolean
   }
   translates: {
      labelApproved: string
      labelToBeApproved: string
      errorMessage: string
      successMessage: string
   }
   approveServiceUrl: string
   tokenId: string
}

export default function ApproveRequestAccessPage(props: Props) {
   const [isApproved, setIsApproved] = useState(props.info?.isApproved || false)
   const [isLoading, setIsLoading] = useState(false)

   const [errorMessage, setErrorMessage] = useState(null)
   const [successMessage, setSuccessMessage] = useState(null)

   async function approveRequest() {
      setIsLoading(true)
      const response = await fetch(props.approveServiceUrl, {
         method: 'POST',
         body: JSON.stringify({ token: props.tokenId, email: props.info?.email?.value })
      })

      const data = await response.json()

      if (response.ok) {
         setIsApproved(true)
         setErrorMessage(null)
         setSuccessMessage(data.message)
      } else {
         setErrorMessage(data.message)
         setSuccessMessage(null)
      }

      setIsLoading(false)
   }

   return (
      <main className="standard-main">
         <Section
            bgColor='bg-beige-primary-light'
            textColor='text-dark'
         >
            <div className="list-offices">

               <div className="grid-container">
                  <div className="grid-row">
                     <div className="c-md-12">
                        <h1 className="title title-lg">{props.heading}</h1>
                        <div style={{margin: '20px 0px'}}>{/* TODO: Set this style as a CSS */}
                           {props.info?.email?.value && <p className='text-md'><strong>{props.info?.email?.label}:</strong> {props.info?.email?.value}</p>}
                           {props.info?.file?.value && <p className='text-md'><strong>{props.info?.file?.label}:</strong> {props.info?.file?.value}</p>}
                           {props.info?.date?.value && <p className='text-md'><strong>{props.info?.date?.label}:</strong> {dayjs.tz(props.info?.date?.value, 'Europe/Oslo').format('DD.MM.YYYY HH:mm (zzz)')}</p>}
                        </div>
                        {
                           isLoading && 
                           <div style={{width: '20px'}}>
                              <Loading />
                           </div>
                        }
                        {
                           props.info && !isLoading &&
                           <Button disabled={isApproved} href='#' color='primary' rightIcon='' size='md' onClick={approveRequest}>
                              {isApproved ? props.translates.labelApproved : props.translates.labelToBeApproved}
                           </Button>
                        }
                        {
                           errorMessage && <p className='text-md error-message'>{errorMessage}</p>
                        }
                        {
                           successMessage && <p className='text-md sent-message'>{successMessage}</p>
                        }
                     </div>
                  </div>
               </div>
            </div>
         </Section>
      </main>
   )
}
